// Shared form data and helpers for landing + /diagnostico route.
// Single source of truth for the qualifying intake.

export const ROLE_OPTIONS = ['Propietario/a', 'Cofundador/a', 'Director/a de operaciones', 'Responsable de procesos', 'Responsable administrativo', 'Responsable de ventas', 'Otro'];

export const SIZE_OPTIONS = ['Solo yo', '2–5', '6–10', '11–20', '21–50', '51–100', 'Más de 100'];

export const REVENUE_OPTIONS_ES = ['Menos de €25k', '€25k–€50k', '€50k–€150k', '€150k–€400k', '€400k–€1M', '€1M–€3M', 'Más de €3M'];

export const REVENUE_OPTIONS_AR = ['Menos de USD 25k', 'USD 25k–50k', 'USD 50k–150k', 'USD 150k–400k', 'USD 400k–1M', 'USD 1M–3M', 'Más de USD 3M'];

export const PHONE_COUNTRIES = [
  { code: 'ES', flag: '🇪🇸', dial: '+34', name: 'España' },
  { code: 'AR', flag: '🇦🇷', dial: '+54', name: 'Argentina' },
  { code: 'MX', flag: '🇲🇽', dial: '+52', name: 'México' },
  { code: 'CO', flag: '🇨🇴', dial: '+57', name: 'Colombia' },
  { code: 'CL', flag: '🇨🇱', dial: '+56', name: 'Chile' },
  { code: 'PE', flag: '🇵🇪', dial: '+51', name: 'Perú' },
  { code: 'UY', flag: '🇺🇾', dial: '+598', name: 'Uruguay' },
  { code: 'US', flag: '🇺🇸', dial: '+1', name: 'Estados Unidos' },
];

export const TOOL_CATALOG = [
  { group: 'Populares', tools: ['HubSpot', 'Salesforce', 'Stripe', 'Zapier', 'Make (Integromat)', 'ChatGPT / OpenAI', 'Slack', 'Notion', 'WhatsApp Business', 'Holded'] },
  { group: 'CRM y ventas', tools: ['HubSpot', 'Salesforce', 'Pipedrive', 'Zoho CRM', 'Holded CRM', 'Clientify', 'Kommo', 'Monday CRM'] },
  { group: 'WhatsApp y comms', tools: ['WhatsApp Business', 'WhatsApp API (Meta)', 'Twilio', '360dialog', 'Callbell', 'Chatwoot', 'Intercom', 'Zendesk'] },
  { group: 'Email y marketing', tools: ['Mailchimp', 'Brevo (Sendinblue)', 'ActiveCampaign', 'Klaviyo', 'Mailerlite', 'Beehiiv'] },
  { group: 'Facturación y finanzas', tools: ['Holded', 'Sage', 'A3', 'Quipu', 'Contasol', 'Xubio', 'Tango Gestión', 'Stripe', 'QuickBooks'] },
  { group: 'Productividad', tools: ['Google Workspace', 'Microsoft 365', 'Notion', 'Slack', 'Trello', 'Asana', 'ClickUp', 'Monday'] },
  { group: 'Automatización y datos', tools: ['Zapier', 'Make (Integromat)', 'n8n', 'Airtable', 'Google Sheets', 'Power Automate'] },
  { group: 'IA y voz', tools: ['ChatGPT / OpenAI', 'Claude', 'Gemini', 'Perplexity', 'ElevenLabs', 'Retell', 'Vapi'] },
  { group: 'Web y e-commerce', tools: ['WordPress', 'Webflow', 'Shopify', 'WooCommerce', 'Tiendanube', 'Framer', 'Squarespace'] },
  { group: 'Teléfono y vídeo', tools: ['Aircall', 'Dialpad', 'RingCentral', 'Zoom', 'Google Meet', 'Microsoft Teams'] }
];

export const TOOL_DOMAINS = {
  'HubSpot': 'hubspot.com',
  'Salesforce': 'salesforce.com',
  'Pipedrive': 'pipedrive.com',
  'Zoho CRM': 'zoho.com',
  'Holded CRM': 'holded.com',
  'Clientify': 'clientify.com',
  'Kommo': 'kommo.com',
  'Monday CRM': 'monday.com',
  'WhatsApp Business': 'whatsapp.com',
  'WhatsApp API (Meta)': 'whatsapp.com',
  'Twilio': 'twilio.com',
  '360dialog': '360dialog.com',
  'Callbell': 'callbell.eu',
  'Chatwoot': 'chatwoot.com',
  'Intercom': 'intercom.com',
  'Zendesk': 'zendesk.com',
  'Mailchimp': 'mailchimp.com',
  'Brevo (Sendinblue)': 'brevo.com',
  'ActiveCampaign': 'activecampaign.com',
  'Klaviyo': 'klaviyo.com',
  'Mailerlite': 'mailerlite.com',
  'Beehiiv': 'beehiiv.com',
  'Holded': 'holded.com',
  'Sage': 'sage.com',
  'A3': 'wolterskluwer.com',
  'Quipu': 'getquipu.com',
  'Contasol': 'sdelsol.com',
  'Xubio': 'xubio.com',
  'Tango Gestión': 'tangogestion.com',
  'Stripe': 'stripe.com',
  'QuickBooks': 'intuit.com',
  'Google Workspace': 'google.com',
  'Microsoft 365': 'microsoft.com',
  'Notion': 'notion.so',
  'Slack': 'slack.com',
  'Trello': 'trello.com',
  'Asana': 'asana.com',
  'ClickUp': 'clickup.com',
  'Monday': 'monday.com',
  'Zapier': 'zapier.com',
  'Make (Integromat)': 'make.com',
  'n8n': 'n8n.io',
  'Airtable': 'airtable.com',
  'Google Sheets': 'google.com',
  'Power Automate': 'microsoft.com',
  'ChatGPT / OpenAI': 'openai.com',
  'Claude': 'anthropic.com',
  'Gemini': 'google.com',
  'Perplexity': 'perplexity.ai',
  'ElevenLabs': 'elevenlabs.io',
  'Retell': 'retellai.com',
  'Vapi': 'vapi.ai',
  'WordPress': 'wordpress.com',
  'Webflow': 'webflow.com',
  'Shopify': 'shopify.com',
  'WooCommerce': 'woocommerce.com',
  'Tiendanube': 'tiendanube.com',
  'Framer': 'framer.com',
  'Squarespace': 'squarespace.com',
  'Aircall': 'aircall.io',
  'Dialpad': 'dialpad.com',
  'RingCentral': 'ringcentral.com',
  'Zoom': 'zoom.us',
  'Google Meet': 'google.com',
  'Microsoft Teams': 'microsoft.com'
};

const LOGO_DEV_TOKEN = 'pk_ZBmPiSB3TSye1q20JH2k5Q';

export function buildLogoUrl(domain, opts = {}) {
  if (!domain) return null;
  const { size = 128, format = 'png', retina = true, greyscale = false } = opts;
  const params = new URLSearchParams({ token: LOGO_DEV_TOKEN, size: String(size), format });
  if (retina) params.set('retina', 'true');
  if (greyscale) params.set('greyscale', 'true');
  return `https://img.logo.dev/${domain}?${params.toString()}`;
}

export const PAIN_SUGGESTIONS_ES = [
  'Tardamos horas en responder consultas de clientes',
  'No tenemos visibilidad sobre el estado de proyectos en tiempo real',
  'Duplicamos datos entre múltiples herramientas',
  'El proceso de onboarding de clientes es manual y lento',
  'No sabemos qué clientes están en riesgo de rotación',
  'Gastamos demasiado tiempo en tareas administrativas repetitivas',
  'No tenemos un pipeline claro de oportunidades de venta',
  'Es difícil trackear el tiempo invertido en cada proyecto',
  'Los reportes para clientes los armamos a mano',
  'Perdemos leads porque no los contactamos a tiempo',
  'No tenemos integración entre CRM, facturación y comunicaciones',
  'Es caótico gestionar múltiples canales de comunicación con clientes'
];

export const PAIN_SUGGESTIONS_AR = [
  'Tardamos horas en responder consultas de clientes',
  'No tenemos visibilidad sobre el estado de proyectos en tiempo real',
  'Duplicamos datos entre múltiples herramientas',
  'El proceso de onboarding de clientes es manual y lento',
  'No sabemos qué clientes están en riesgo de rotación',
  'Gastamos demasiado tiempo en tareas administrativas repetitivas',
  'No tenemos un pipeline claro de oportunidades de venta',
  'Es difícil trackear el tiempo invertido en cada proyecto',
  'Los reportes para clientes los armamos a mano',
  'Perdemos leads porque no los contactamos a tiempo',
  'No tenemos integración entre CRM, facturación y comunicaciones',
  'Es caótico gestionar múltiples canales de comunicación con clientes'
];

export const RIOPLATENSE_LOCALES = ['es-ar', 'es-uy', 'es-py'];

// Forking question lever catalog — 3 ROI levers (Q29).
// value: stable machine token sent to API + Notion.
// castellano/rioplatense: dialect-aware display labels.
export const LEVER_OPTIONS = [
  { value: 'efectividad', castellano: 'Ganar más dinero',             rioplatense: 'Ganar más dinero' },
  { value: 'eficiencia',  castellano: 'Recuperar horas de mi semana', rioplatense: 'Recuperar horas de mi semana' },
  { value: 'calidad',     castellano: 'Tener clientes más contentos', rioplatense: 'Tener clientes más contentos' },
];

export const SIGNAL_CATALOG = [
  { id: 'lead_intake', castellano: 'Recepción de consultas y leads', rioplatense: 'Recepción de consultas y leads',
    probe: { castellano: '¿Cuántas consultas/leads al mes?', rioplatense: '¿Cuántas consultas/leads al mes?' } },
  { id: 'call_recording', castellano: 'Llamadas y reuniones con clientes', rioplatense: 'Llamadas y reuniones con clientes',
    probe: { castellano: '¿Cuántas a la semana?', rioplatense: '¿Cuántas a la semana?' } },
  { id: 'customer_dormancy', castellano: 'Clientes dormidos / antiguos', rioplatense: 'Clientes dormidos / antiguos',
    probe: { castellano: '¿Cuántos contactos inactivos?', rioplatense: '¿Cuántos contactos inactivos?' } },
  { id: 'invoicing_data_entry', castellano: 'Entrada manual de facturas', rioplatense: 'Entrada manual de facturas',
    probe: { castellano: '¿Cuántas facturas al mes?', rioplatense: '¿Cuántas facturas al mes?' } },
  { id: 'quoting', castellano: 'Presupuestos y cotizaciones', rioplatense: 'Presupuestos y cotizaciones',
    probe: { castellano: '¿Cuántos al mes?', rioplatense: '¿Cuántos al mes?' } },
  { id: 'scheduling_reminders', castellano: 'Agendas y recordatorios de citas', rioplatense: 'Agendas y recordatorios de citas',
    probe: { castellano: '¿Cuántas citas a la semana?', rioplatense: '¿Cuántas citas a la semana?' } },
  { id: 'email_triage', castellano: 'Correos repetitivos', rioplatense: 'Correos repetitivos',
    probe: { castellano: '¿Cuántos correos repetitivos al día (equipo)?', rioplatense: '¿Cuántos correos repetitivos al día (equipo)?' } },
  { id: 'internal_qa', castellano: 'Buscar información o documentos del negocio', rioplatense: 'Buscar información o documentos del negocio',
    probe: { castellano: '¿Con qué frecuencia el equipo lo hace?', rioplatense: '¿Con qué frecuencia el equipo lo hace?' } },
  { id: 'reporting', castellano: 'Reportes y planillas manuales', rioplatense: 'Reportes y planillas manuales',
    probe: { castellano: '¿Cuántos reportes al mes?', rioplatense: '¿Cuántos reportes al mes?' } },
  { id: 'consolidation', castellano: 'Datos duplicados entre herramientas', rioplatense: 'Datos duplicados entre herramientas' /* no probe */ },
];

export const VOLUME_BANDS = {
  lead_intake:          { bands: ['<20', '20-100', '100+'], labels: ['Menos de 20', '20 a 100', 'Más de 100'] },
  call_recording:       { bands: ['<10', '10-30', '30+'],   labels: ['Menos de 10', '10 a 30', 'Más de 30'] },
  customer_dormancy:    { bands: ['<200', '200-1000', '1000+'], labels: ['Menos de 200', '200 a 1.000', 'Más de 1.000'] },
  invoicing_data_entry: { bands: ['<50', '50-200', '200+'], labels: ['Menos de 50', '50 a 200', 'Más de 200'] },
  quoting:              { bands: ['<10', '10-40', '40+'],   labels: ['Menos de 10', '10 a 40', 'Más de 40'] },
  scheduling_reminders: { bands: ['<20', '20-80', '80+'],   labels: ['Menos de 20', '20 a 80', 'Más de 80'] },
  email_triage:         { bands: ['<20', '20-80', '80+'],   labels: ['Menos de 20', '20 a 80', 'Más de 80'] },
  internal_qa:          { bands: ['poco', 'a_diario', 'constantemente'], labels: ['Pocas veces', 'A diario', 'Constantemente'] },
  reporting:            { bands: ['<5', '5-20', '20+'],     labels: ['Menos de 5', '5 a 20', 'Más de 20'] },
};

export function detectInitialDialect() {
  if (typeof window === 'undefined') return null;
  try {
    const stored = window.localStorage.getItem('ea_dialect');
    if (stored === 'castellano' || stored === 'rioplatense') return stored;
  } catch (e) { /* localStorage blocked */ }
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']).map((l) => (l || '').toLowerCase());
  for (const l of langs) {
    if (RIOPLATENSE_LOCALES.some((r) => l === r || l.startsWith(r + '-'))) return 'rioplatense';
  }
  return null;
}

// SPA navigation helper. Lightweight pushState + popstate dispatch.
export function navigateTo(path) {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo(0, 0);
}
